import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        pending_withdrawals: {
          header: 'HEADER',
          download_report_button: 'DOWNLOAD_REPORT',
          modal_windows: {
            approve_withdrawal: {
              title: 'APPROVE_TITLE',
              question: 'APPROVE_QUESTION',
              approve: 'APPROVE_YES',
              cancel: 'APPROVE_NO',
            },
            denial_withdrawal: {
              title: 'DENIAL_TITLE',
              question: 'DENIAL_QUESTION',
              proceed: 'DENIAL_YES',
              cancel: 'DENIAL_NO',
            },
            reason_for_denial: {
              title: 'REASON_DENIAL_TITLE',
              reason: 'REASON_DENIAL_REASON',
              proceed: 'REASON_DENIAL_PROCEED',
              cancel: 'REASON_DENIAL_CANCEL',
            },
          },
          view_withdrawal: {
            header: 'VIEW_HEADER',
            back: 'VIEW_BACK',
            approve_withdrawal_button: 'VIEW_APPROVE',
            denial_withdrawal_button: 'VIEW_DENY',
            form: {
              merchant_name: 'FORM_MERCHANT_NAME',
              affiliate_id: 'FORM_AFFILIATE_ID',
              amount: 'FORM_AMOUNT',
              created_at: 'FORM_CREATED_AT',
              payment_system_name: 'FORM_PAYMENT_SYSTEM_NAME',
              creator_type: 'FORM_CREATOR_TYPE',
              creator_id: 'FORM_CREATOR_ID',
              creator_email: 'FORM_CREATOR_EMAIL',
            },
          },
        },
      },
    },
  }));
}
